import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BikeCard from 'components/_cards/BikeCard/BikeCard';
import Button from 'components/Button/Button';
import PlaceholderBikeCard from 'components/_cards/PlaceholderBikeCard/PlaceholderBikeCard';
import Loader from 'components/_utility/Loader/Loader';
import request from 'helpers/request';
import Label from 'components/_utility/Label';
import Breadcrumb from 'components/_utility/Breadcrumb/Breadcrumb';
import { setResults, loadMore } from 'src/redux/bikes/actions';
import { bikesSelector, getBikesView } from 'src/redux/bikes/selectors';
import Modal from 'components/_utility/Modal/Modal';
import DisclaimerModal from 'components/DisclaimerModal/DisclaimerModal';
import { openModalSelector } from 'src/redux/configurator/selectors';
import { setSelectedDisclaimer, closeModal } from 'src/redux/configurator/actions';
import { setError } from 'src/redux/app/actions';
import NoResults from 'components/_utility/NoResults/NewResults';
import { Wrap, ButtonWrap } from './BikeGrid.styled';

const BikeGrid = ({ familyId }) => {
  const dispatch = useDispatch();

  const { filteredCount, results: bikes } = useSelector(bikesSelector);
  const bikeView = useSelector(getBikesView);
  const isListView = bikeView === 'list';
  const openModals = useSelector(openModalSelector);

  const [loading, setLoading] = useState(true);
  const [loadingAdditional, setLoadingAdditional] = useState(true);

  useEffect(() => {
    const fetchBikes = async () => {
      setLoading(true);

      let url = '/api/configurator/bikes/models';

      if (familyId) {
        url += `?family=${familyId}`;
      }

      try {
        const res = await request(url);

        dispatch(setResults(res.data.bikes));
        setLoading(false);
        setLoadingAdditional(false);
      } catch (ex) {
        dispatch(setError(ex));
      }
    };

    fetchBikes();
  }, [dispatch, familyId]);

  const currentFamilyName = familyId && bikes.length ? bikes[0].family : <Label name="configureLabel" />;

  return (
    <>
      {loading ? (
        <>
          <Wrap listView={isListView}>
            {new Array(8).fill().map((_, index) => (
              <PlaceholderBikeCard key={index} isListingsPage listView={isListView} />
            ))}
          </Wrap>
          <Loader />
        </>
      ) : (
        <Wrap data-testid="bikecards" listView={isListView}>
          {bikes.length ? (
            bikes.map(bike => (
              <BikeCard data-testid="bikecard" key={bike.id} bike={bike} listView={isListView} isListingsPage />
            ))
          ) : (
            <NoResults />
          )}
        </Wrap>
      )}
      <ButtonWrap>
        {bikes.length < filteredCount ? (
          <Button
            onClick={() => {
              setLoadingAdditional(true);

              setTimeout(() => [dispatch(loadMore()), setLoadingAdditional(false)], 100);
            }}
            disabled={loadingAdditional}
            wide
          >
            {loadingAdditional ? <Label name="loadingLabel"></Label> : <Label name="loadMoreLabel"></Label>}
          </Button>
        ) : null}
      </ButtonWrap>
      {openModals.disclaimer ? (
        <Modal onClose={() => [dispatch(closeModal('disclaimer')), dispatch(setSelectedDisclaimer(null))]}>
          <DisclaimerModal />
        </Modal>
      ) : null}
      <Breadcrumb
        additionalLinks={[
          familyId
            ? {
                text: currentFamilyName,
                siteLink: false,
              }
            : {
                text: <Label name="viewAllButton" />,
                siteLink: false,
              },
        ]}
      />
    </>
  );
};

export default BikeGrid;
